// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"7807be98e0523c00d763","655":"3c51d9670bffbed44a2e"}[chunkId] + ".js";
};